import { Field } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

const FormikCheckbox = ({
  md,
  sm,
  controlId,
  label,
  name,
  className,
  disabled,
  onChange,
}) => {
  return (
    <Field
      name={name}
      render={({ field, form }) => {
        const isValid = !form.errors[field.name];
        const isInvalid = form.touched[field.name] && !isValid;
        return (
          <Form.Group
            md={md}
            sm={sm}
            controlId={controlId}
            className={`form-group ${className}`}
          >
            <Form.Check
              type="checkbox"
              name={name}
              label={label}
              onChange={(e) => {
                form.setFieldValue(controlId, e.target.checked);
                if (onChange) {
                  onChange(e, form);
                }
              }}
              isInvalid={isInvalid}
              checked={field.value}
              feedback={form.errors[field.name]}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">
              {form.errors[field.name]}
            </Form.Control.Feedback>
          </Form.Group>
        );
      }}
    />
  );
};

export default FormikCheckbox;
